import type { ReactNode } from 'react';
import { cn } from './cn';

/** Espaçamento padrão de uma página dentro do layout, em largura total. */
export function Page({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={cn('px-4 py-8 sm:px-6 lg:px-8', className)}>{children}</div>;
}
